import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  min-height: 0;

  .updates-list {
    min-width: 0;
  }

  .update-chip {
    white-space: nowrap;
  }

  .update-card {
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.$gray300};
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }

  .update-card-active {
    border-color: ${(props) => props.theme.$success};
  }

  .update-icon {
    width: 32px;
    height: 32px;
    background: ${(props) => props.theme.$gray200};
  }

  .update-icon .material-icons {
    font-size: 18px;
  }

  .update-title {
    color: ${(props) => props.theme.$dark};
  }

  .update-author,
  .update-date {
    font-size: 13px;
  }

  .update-body {
    font-size: 14px;
    color: ${(props) => props.theme.$gray700};
  }

  .update-message + .update-message {
    padding-top: 8px;
    border-top: 1px solid ${(props) => props.theme.$gray200};
  }

  .update-message-head {
    font-size: 12px;
    font-weight: 600;
  }

  .update-pane {
    width: 480px;
    max-width: 50%;
    min-height: 0;
  }

  .update-pane-body {
    overflow-y: auto;
  }

  .update-pane h4,
  .update-section-title {
    color: ${(props) => props.theme.$dark};
  }

  .update-section-title {
    font-weight: 600;
    margin-top: 1.5rem;
    margin-bottom: 0.5rem;
  }

  .update-field-label {
    color: ${(props) => props.theme.$gray700};
    font-size: 13px;
  }

  .files-table th {
    font-weight: 600;
    color: ${(props) => props.theme.$gray700};
    border-top: 0;
    white-space: nowrap;
  }

  .files-table td {
    vertical-align: middle;
  }

  .min-width-0 {
    min-width: 0;
  }

  .material-icons {
    font-size: 16px;
  }

  .notes-input-group .material-icons {
    font-size: 24px;
  }
`;
